import { render, staticRenderFns } from "./contact-form-cmp.vue?vue&type=template&id=82455372&scoped=true"
import script from "./contact-form-cmp.vue?vue&type=script&lang=js"
export * from "./contact-form-cmp.vue?vue&type=script&lang=js"
import style0 from "./contact-form-cmp.vue?vue&type=style&index=0&id=82455372&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82455372",
  null
  
)

export default component.exports